export default "assets/images/logo-f9690a1b.png";